<div [ngClass]="modalSizeClasses" class="modal rounded-lg shadow overflow-hidden">
  <ng-content select="[modal-header]"></ng-content>
  <ng-container *ngIf="!title || hasCustomHeader; else defaultHeader"></ng-container>
  <ng-template #defaultHeader>
    <div class="modal-header">
      <h3 class="modal-title">{{ title }}</h3>
      <button (click)="close()" type="button" class="close-btn">
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"></path>
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
  </ng-template>
  <div [ngClass]="{'modal-body': !disableBodyClass}" class="overflow-y-auto">
    <ng-content select="[modal-body]"></ng-content>
  </div>
  <div class="modal-footer w-full flex justify-end gap-2">
    <ng-content select="[modal-footer]"></ng-content>
  </div>
</div> 